import {
  collection,
  doc,
  setDoc,
  getDoc,
  getDocs,
  deleteDoc,
  addDoc,
  query,
  orderBy,
  serverTimestamp
} from 'firebase/firestore';
import { db } from './config';

// Get reference to user's lesson plans collection
const getUserLessonsCollection = (userId) => {
  return collection(db, 'users', userId, 'lessonPlans');
};

// Create a new lesson plan
export const createLessonPlan = async (userId, lessonData) => {
  try {
    const lessonsRef = getUserLessonsCollection(userId);
    const docRef = await addDoc(lessonsRef, {
      ...lessonData,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error('Error creating lesson plan:', error);
    return { success: false, error };
  }
};

// Update a lesson plan
export const updateLessonPlan = async (userId, lessonId, lessonData) => {
  try {
    const lessonRef = doc(db, 'users', userId, 'lessonPlans', lessonId);
    await setDoc(lessonRef, {
      ...lessonData,
      updatedAt: serverTimestamp()
    }, { merge: true });
    return { success: true };
  } catch (error) {
    console.error('Error updating lesson plan:', error);
    return { success: false, error };
  }
};

// Delete a lesson plan
export const deleteLessonPlan = async (userId, lessonId) => {
  try {
    const lessonRef = doc(db, 'users', userId, 'lessonPlans', lessonId);
    await deleteDoc(lessonRef);
    return { success: true };
  } catch (error) {
    console.error('Error deleting lesson plan:', error);
    return { success: false, error };
  }
};

// Get all lesson plans for a user
export const getLessonPlans = async (userId) => {
  try {
    const lessonsRef = getUserLessonsCollection(userId);
    const q = query(lessonsRef, orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);
    const lessons = [];
    querySnapshot.forEach((doc) => {
      lessons.push({ id: doc.id, ...doc.data() });
    });
    return { success: true, lessons };
  } catch (error) {
    console.error('Error getting lesson plans:', error);
    return { success: false, error };
  }
};

// Get a single lesson plan
export const getLessonPlan = async (userId, lessonId) => {
  try {
    const lessonRef = doc(db, 'users', userId, 'lessonPlans', lessonId);
    const lessonSnap = await getDoc(lessonRef);

    if (lessonSnap.exists()) {
      return { success: true, lesson: { id: lessonSnap.id, ...lessonSnap.data() } };
    } else {
      return { success: false, error: 'Lesson plan not found' };
    }
  } catch (error) {
    console.error('Error getting lesson plan:', error);
    return { success: false, error };
  }
};
